import React, { useState } from 'react';
import Post from '../components/Post';

function PostDesigner() {
  const [formData, setFormData] = useState({
    type: 'blog',
    title: 'New Post Title',
    date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    content: 'Write your post content here...',
    image: '',
    skills: '',
    link: '',
    linkText: 'Read More'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const skillsArray = formData.skills.split(',').map(s => s.trim()).filter(s => s);

  const previewPost = {
    id: 999,
    type: formData.type,
    title: formData.title,
    date: formData.date,
    content: formData.content,
    image: formData.image,
    skills: skillsArray,
    link: formData.link,
    linkText: formData.linkText
  };

  const outputCode = `{
  id: 5,
  type: '${formData.type}',
  title: '${formData.title.replace(/'/g, "\\'")}',
  date: '${formData.date}',
  content: \`${formData.content.replace(/`/g, '\\`')}\`,
${formData.image ? `  image: '${formData.image}',\n` : ''}${skillsArray.length > 0 ? `  skills: ${JSON.stringify(skillsArray)},\n` : ''}${formData.link ? `  link: '${formData.link}',\n  linkText: '${formData.linkText}'\n` : ''}}`;

  return (
    <div style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 24px', display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
      <div style={{ flex: '1 1 400px' }}>
        <h2 style={{ marginBottom: '24px' }}>Post Designer</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', background: '#111', padding: '24px', borderRadius: '12px', border: '1px solid #262626' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Type</label>
            <select name="type" value={formData.type} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }}>
              <option value="blog">Blog</option>
              <option value="project">Project</option>
              <option value="research">Research</option>
              <option value="chess">Chess</option>
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Title</label>
            <input type="text" name="title" value={formData.title} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Date</label>
            <input type="text" name="date" value={formData.date} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Content</label>
            <textarea name="content" value={formData.content} onChange={handleChange} rows="5" style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px', fontFamily: 'inherit' }} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Image URL (optional)</label>
            <input type="text" name="image" value={formData.image} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Skills (comma separated)</label>
            <input type="text" name="skills" value={formData.skills} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>External Link (optional)</label>
            <input type="text" name="link" value={formData.link} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }} />
          </div>
          {formData.link && (
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: '#a3a3a3' }}>Link Text</label>
              <input type="text" name="linkText" value={formData.linkText} onChange={handleChange} style={{ width: '100%', padding: '10px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '6px' }} />
            </div>
          )}
        </div>
      </div>
      
      <div style={{ flex: '1 1 400px' }}>
        <h2 style={{ marginBottom: '24px' }}>Live Preview</h2>
        <Post post={previewPost} />
        
        <h3 style={{ marginTop: '32px', marginBottom: '16px', color: '#a3a3a3' }}>Generated Code</h3>
        <p style={{ fontSize: '0.85rem', color: '#a3a3a3', marginBottom: '16px' }}>Copy and paste this object into the array in <code>client/src/data/posts.js</code>.</p>
        <pre style={{ background: '#0a0a0a', border: '1px solid #262626', padding: '16px', borderRadius: '8px', overflowX: 'auto', fontSize: '0.9rem', color: '#4ade80' }}>
          {outputCode}
        </pre>
      </div>
    </div>
  );
}

export default PostDesigner;
